/* Browser-local preferences from deliberate size choices. No account or cart is modified. */
(() => {
  if (window.SizeMemory) return;
  const key = 'garment-size-preferences.v1';
  const maxAge = 180 * 24 * 60 * 60 * 1000;
  const normalize = value => String(value || '').trim().toLocaleLowerCase();
  let volatile = {};
  function read() {
    try {
      const parsed = JSON.parse(localStorage.getItem(key) || '{}');
      if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) return parsed;
    } catch (_) {}
    return volatile;
  }
  function remember(scope, value) {
    if (!scope || !value) return;
    const state = read();
    state[scope] = { value: String(value), updatedAt: Date.now() };
    volatile = Object.fromEntries(Object.entries(state).filter(([, entry]) =>
      entry && typeof entry.value === 'string' && Number.isFinite(entry.updatedAt) && Date.now() >= entry.updatedAt && Date.now() - entry.updatedAt < maxAge
    ).slice(-100));
    try { localStorage.setItem(key, JSON.stringify(volatile)); } catch (_) {}
    document.dispatchEvent(new CustomEvent('size-memory:change', {detail:{scope}}));
  }
  function get(scope) {
    const entry = read()[scope];
    return entry && typeof entry.value === 'string' && Number.isFinite(entry.updatedAt) && Date.now() >= entry.updatedAt && Date.now() - entry.updatedAt < maxAge ? entry.value : '';
  }
  function option(group, value) {
    if (!group || !value) return null;
    return [...group.querySelectorAll('input[type="radio"],select option')].find(node =>
      normalize(node.value) === normalize(value) && !node.disabled &&
      !node.classList.contains('disabled') && node.dataset.optionAvailable !== 'false'
    ) || null;
  }
  const bound = new WeakSet();
  function bindQuick(form) {
    if (bound.has(form)) return;
    bound.add(form);
    const select = form.querySelector('select[name="id"]');
    const scope = form.dataset.sizeScope;
    if (!select || !scope) return;
    let explicit = false;
    function restore() {
      if (explicit) return;
      const value = get(scope);
      // Multiple available lengths/colours require an explicit choice; never pick the first.
      const matches = [...select.options].filter(o => !o.disabled && o.dataset.size && normalize(o.dataset.size) === normalize(value));
      const previous = select.value;
      select.value = matches.length === 1 ? matches[0].value : '';
      if (select.value !== previous) form.dispatchEvent(new CustomEvent('size-memory:restored'));
    }
    select.addEventListener('change', () => {
      const choice = select.selectedOptions[0];
      if (choice && !choice.disabled) { explicit = true; remember(scope, choice.dataset.size); }
    });
    form.closest('details')?.addEventListener('toggle', restore);
    document.addEventListener('size-memory:change', event => { if (form.isConnected && event.detail.scope === scope) restore(); });
    restore();
  }
  function refresh(scope = document) {
    if (scope.matches?.('[data-rx-quick-form]')) bindQuick(scope);
    scope.querySelectorAll?.('[data-rx-quick-form]').forEach(bindQuick);
  }
  window.SizeMemory = { get, remember, option, refresh };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => refresh()); else refresh();
  document.addEventListener('shopify:section:load', e => refresh(e.target));
  document.addEventListener('product-recommendations:loaded', e => refresh(e.target));
  new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) if (node.nodeType === 1) refresh(node);
  }).observe(document.documentElement, {childList:true,subtree:true});
})();
